import getClassNames from "../../Utils/getClassNames";

export default function ResultValue({ label, value, labelClassName, valueClassName }) {
    return (
        <div className="row align-items-center">
            <div className={getClassNames('col', labelClassName)}>
                {label}
            </div>
            {value !== undefined && 
                <div className={getClassNames('col text-end', valueClassName)} style={{ whiteSpace: 'nowrap' }}>
                    {value}
                </div>
            }
        </div>
    );
};